import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const MenuContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 30%;
  min-width: 500px;
  border-radius: 0 30px 30px 0;
  background-color: white;
  flex-direction: column;
  position: absolute;
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 16px;
  @media (min-height: 700px) {
    justify-content: center;
  }
`;

export const TextContainer = styled.div`
  width: 80%;
  display: block;
`;

export const SubmitButtonContainer = styled.div`
  margin-top: 50px;
`;

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 1.5rem 0;
  height: max-content;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`;

export const LinkContainer = styled.div`
  min-width: max-content;
  display: flex;
  justify-content: space-between;
`;

// Images

export const Logo = styled.img`
  width: 60%;
  height: auto;
  margin-bottom: 25px;
`;

export const BackgroundImage = styled.img`
  height: 100%;
  min-width: calc(100vw - 450px);
`;

// Texts

export const Text = styled.p`
  font-size: 13px;
  margin: 4px;
  padding: 0;
`;

export const GrayText = styled(Text)`
  color: #3b3b3b;
  font-weight: bold;
`;

export const RedText = styled(Text)`
  color: #ff0000;
`;

export const GreenText = styled(Text)`
  color: #00ff00;
`;

export const FormTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
`;

export const ErrorText = styled(Text)`
  color: red;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;
